<template>
  <div class="">
    <NuxtLoadingIndicator color="red" />
    <div class="shadow">
      <UContainer class="py-4">
        <div class="flex">
          <div class="flex-1">
            <NuxtLink to="/" class="mr-6"><img src="~/assets/icons/emblem-fc.svg" alt="Frederique Constant"
                class="h-6 inline-block mr-2" /><img src="~/assets/icons/emblem-al.svg" alt="Alpina"
                class="h-4 inline-block mr-4" /><span class="uppercase">Retailer Locator</span></NuxtLink>
          </div>
          <div class="self-end">
            <UButton to="/distributors" color="neutral" variant="outline" class="uppercase mr-2"
              :class="{ 'bg-gray-200 font-bold': isActive('/distributors') }">Distribution</UButton>

            <UButton to="/retailers" color="neutral" variant="outline" class="uppercase mr-2"
              :class="{ 'bg-gray-200 font-bold': isActive('/retailers') }">Retailers</UButton>

            <UButton v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87'" to="/users" color="neutral"
              variant="outline" class="mr-2 uppercase" :class="{ 'bg-gray-200 font-bold': isActive('/users') }">Users
            </UButton>

            <UButton v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87'" to="/admin" color="neutral"
              variant="outline" class="mr-2 uppercase" :class="{ 'bg-gray-200 font-bold': isActive('/admin') }">Admin
            </UButton>

            <UButton v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87'" to="/data" color="neutral"
              variant="outline" class="mr-2 uppercase" :class="{ 'bg-gray-200 font-bold': isActive('/data') }">Ewarranty Data
            </UButton>

            <!-- Dropdown personnalisé -->
            <div class="relative inline-block mr-2" ref="dropdownRef">
              <UButton color="neutral" variant="outline" class="uppercase" @click="toggleDropdown">
                Ewarranty Access
                <svg class="ml-2 w-4 h-4" :class="{ 'rotate-180': isDropdownOpen }" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </UButton>

              <!-- Menu dropdown -->
              <div v-show="isDropdownOpen"
                class="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                <div class="py-1">
                  <button @click="openAlpina"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                    <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                    Alpina
                  </button>
                  <button @click="openFC"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                    <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                    Frederique Constant
                  </button>
                </div>
              </div>
            </div>

            <UButton v-if="user" color="red" variant="solid" class="uppercase ml-2 text-red-600 border hover:bg-red-100"
              @click="handleLogout">
              Logout
            </UButton>
          </div>
        </div>
      </UContainer>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
const user = useDirectusUser()
const { logout } = useDirectusAuth()
const router = useRouter()
const route = useRoute()

const isActive = (path: string) => {
  return route.path === path
}

const handleLogout = async () => {
  await logout()
  router.push('/login')
}

// Dropdown state
const isDropdownOpen = ref(false)
const dropdownRef = ref(null)

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value
}

const openAlpina = () => {
  console.log('Opening Alpina...')
  window.open('https://ewarranty.alpinawatches.com/', '_blank')
  isDropdownOpen.value = false
}

const openFC = () => {
  console.log('Opening FC...')
  window.open('https://ewarranty.frederiqueconstant.com/', '_blank')
  isDropdownOpen.value = false
}

// Fermer le dropdown si on clique ailleurs
const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isDropdownOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>